(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (() => {
            if (typeof $ === "undefined" || typeof jQuery === "undefined") {
                console.error("jQuery is not loaded. Bundle shopping functionality requires jQuery.");
                return;
            }
            $((() => {
                if (window.custom_bundle_shopping) {
                    return;
                }
                window.custom_bundle_shopping = true;
                const bundles = $(".custom-bundle-shopping-init");
                if ($(bundles).length > 0) {
                    $("#QuickView-Modal").addClass("custom-bundles");
                    const windowWidth = $(window).width();
                    function add_price(obj, bundle__price, bundle__save, discountRate = .06) {
                        let totalPrice = 0;
                        let itemCount = 0;
                        $.each(obj, (function() {
                            const priceTemp = $(this).data("price");
                            totalPrice += parseFloat(priceTemp);
                            itemCount++;
                        }));
                        if (itemCount > 1) {
                            const discount = totalPrice * discountRate;
                            const finalPrice = totalPrice - discount;
                            $(bundle__save).text((discount / 100).toFixed(2));
                            $(bundle__price).text((finalPrice / 100).toFixed(2));
                        } else {
                            $(bundle__save).text("0.00");
                            $(bundle__price).text((totalPrice / 100).toFixed(2));
                        }
                    }
                    bundles.each((function(index, bundle) {
                        const bundle_lists = $(bundle).find(".product-card");
                        $.each(bundle_lists, (function(i_, v_) {
                            const bundle_media = $(v_).find("img");
                            const bundle_bundle_media_id = $(v_).data("table-product");
                            $(bundle_media).off("click.bundleMedia").on("click.bundleMedia", (function(event) {
                                if ($(event.target).closest(".product-card__pick").length) {
                                    return;
                                }
                                event.stopPropagation();
                                const bundle_button = $(bundle).find("[data-bundle-hotspot=" + bundle_bundle_media_id + "]");
                                $(bundle_button).find("button").click();
                            }));
                            const card__pick = $(v_).find(".product-card__pick");
                        }));
                        const bundle__price = $(bundle).find(".bundle__price span");
                        const bundle__save = $(bundle).find(".bundle__save span");
                        const selectedDiscountedPrices = $(bundle).find(".product-card:not(._handpick) .discounted-price");
                        add_price(selectedDiscountedPrices, bundle__price, bundle__save);
                        $(bundle).find(".product-card__pick").each((function() {
                            const card__pick = $(this);
                            $(card__pick).off("click.cardPick").on("click.cardPick", (function(event) {
                                event.stopPropagation();
                                if ($(this).attr("pick") === "true") {
                                    $(this).attr("pick", "false");
                                    $(this).closest(".product-card").addClass("_handpick");
                                } else {
                                    $(this).attr("pick", "true");
                                    $(this).closest(".product-card").removeClass("_handpick");
                                }
                                const selectedDiscountedPrices = $(bundle).find(".product-card:not(._handpick) .discounted-price");
                                const bundlePriceSpan = $(bundle).find(".bundle__price span");
                                const bundleSaveSpan = $(bundle).find(".bundle__save span");
                                add_price(selectedDiscountedPrices, bundlePriceSpan, bundleSaveSpan);
                            }));
                        }));
                        const bundleElement = $(bundle);
                        bundleElement.find(".add_to_cards .btn--primary").off("click.shopIdea").on("click.shopIdea", (function(evt) {
                            evt.preventDefault();
                            const selectedProducts = [];
                            bundleElement.find(".product-card__pick[pick='true']").each((function() {
                                const variantId = $(this).data("variant-id");
                                if (variantId) {
                                    selectedProducts.push({
                                        id: variantId,
                                        quantity: 1
                                    });
                                }
                            }));
                            if (selectedProducts.length === 0) {
                                showNotification("Please select at least one product", "warning");
                                return;
                            }
                            addItemsToCartAndUpdate(selectedProducts);
                        }));
                        const bundleViewAll = $(bundle).find(".bundle-view-all");
                        const lookbook__hotspots = $(bundle).find(".lookbook__hotspot__details");
                        const custom_sm_info = $(bundle).find(".lookbook-sm-info");
                        const close = $(bundle).find(".close-button");
                        $(close).off("click.closeBundle").on("click.closeBundle", (function() {
                            if ($(custom_sm_info).hasClass("is-action")) {
                                $(custom_sm_info).removeClass("is-action");
                                $(bundleViewAll).removeClass("is-action");
                            }
                        }));
                        $(bundleViewAll).off("click.viewAll").on("click.viewAll", (function() {
                            if (!$(this).hasClass("is-action")) {
                                $(this).addClass("is-action");
                                if (windowWidth > 768) {
                                    $(lookbook__hotspots).attr("open", true);
                                } else {
                                    $(custom_sm_info).addClass("is-action");
                                }
                            } else {
                                $(this).removeClass("is-action");
                                if (windowWidth > 768) {
                                    $(lookbook__hotspots).attr("open", false);
                                } else {
                                    $(custom_sm_info).removeClass("is-action");
                                }
                            }
                        }));
                    }));
                    function showNotification(message, type = "info") {
                        const notification = document.createElement("div");
                        notification.className = `bundle-notification bundle-notification--${type}`;
                        notification.textContent = message;
                        Object.assign(notification.style, {
                            position: "fixed",
                            top: "20px",
                            right: "20px",
                            padding: "12px 20px",
                            borderRadius: "4px",
                            color: "#fff",
                            fontSize: "14px",
                            fontWeight: "500",
                            zIndex: "9999",
                            maxWidth: "300px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            transform: "translateX(100%)",
                            transition: "transform 0.3s ease-in-out"
                        });
                        const colors = {
                            success: "rgb(1, 187, 213)",
                            error: "#dc3545",
                            warning: "#ffc107",
                            info: "#17a2b8"
                        };
                        notification.style.backgroundColor = colors[type] || colors.info;
                        document.body.appendChild(notification);
                        setTimeout((() => {
                            notification.style.transform = "translateX(0)";
                        }), 100);
                        setTimeout((() => {
                            notification.style.transform = "translateX(100%)";
                            setTimeout((() => {
                                if (notification.parentNode) {
                                    notification.parentNode.removeChild(notification);
                                }
                            }), 300);
                        }), 3e3);
                    }
                    function addItemsToCartAndUpdate(items) {
                        const formData = {
                            sections: [ "cart-drawer", "cart-icon-bubble" ],
                            sections_url: window.location.pathname,
                            items: items
                        };
                        const config = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/javascript"
                            },
                            body: JSON.stringify(formData)
                        };
                        fetch("/cart/add.js", config).then((response => {
                            if (!response.ok) {
                                throw new Error(`HTTP error! status: ${response.status}`);
                            }
                            return response.json();
                        })).then((response => {
                            if (response.status) {
                                console.error("Error adding items:", response.description);
                                showNotification("Failed to add items: " + (response.description || "Unknown error"), "error");
                                return;
                            }
                            updateCartDrawer(response);
                            showNotification("Items successfully added to cart", "success");
                        })).catch((error => {
                            console.error("Error adding items to cart:", error);
                            showNotification("Failed to add items to cart, please try again", "error");
                        }));
                    }
                    function getSectionInnerHTML(html, selector) {
                        const element = (new DOMParser).parseFromString(html, "text/html").querySelector(selector);
                        return element ? element.innerHTML : "";
                    }
                    function getSectionsToRender() {
                        return [ {
                            id: "cart-drawer",
                            selector: ".cart-drawer__items"
                        }, {
                            id: "cart-drawer",
                            selector: ".cart-drawer__footer--subtotal"
                        }, {
                            id: "cart-icon-bubble"
                        } ];
                    }
                    function updateCartDrawer(response) {
                        const drawerInner = document.querySelector(".drawer__inner");
                        if (drawerInner && drawerInner.classList.contains("is-empty")) {
                            drawerInner.classList.remove("is-empty");
                        }
                        getSectionsToRender().forEach((section => {
                            const sectionHTML = section.selector ? getSectionInnerHTML(response.sections[section.id], section.selector) : response.sections[section.id];
                            if (sectionHTML) {
                                const targetElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                                if (targetElement) {
                                    targetElement.innerHTML = sectionHTML;
                                } else {
                                    console.warn(`Target element for ${section.selector || section.id} not found.`);
                                }
                            } else {
                                console.error(`Failed to extract content for ${section.selector || section.id}.`);
                            }
                        }));
                        setTimeout((() => {
                            const overlay = document.querySelector("#CartDrawer-Overlay");
                            if (overlay) {
                                overlay.addEventListener("click", (() => {
                                    const cartDrawer = document.querySelector("cart-drawer");
                                    if (cartDrawer && typeof cartDrawer.close === "function") {
                                        cartDrawer.close();
                                    }
                                }));
                            }
                            const cartDrawer = document.querySelector("cart-drawer");
                            if (cartDrawer && typeof cartDrawer.open === "function") {
                                cartDrawer.classList.remove("is-empty");
                                cartDrawer.open();
                            }
                        }), 0);
                    }
                    function bindAddToCartEvents() {
                        const quick_views = $("quick-view-modal");
                        $(quick_views).find(".add").off("click.addToCart");
                        $(quick_views).find(".add").on("click.addToCart", (function(event) {
                            event.preventDefault();
                            $(quick_views).find(".product-form__submit").click();
                        }));
                    }
                    function fetchList(swat, quickViewModal, showNotification = false) {
                        return $.Deferred((deferred => {
                            const onSuccess = lists => {
                                window.swymWishLists = lists;
                                window.swymSelectedListId = lists && lists[0] && lists[0].lid;
                                updateButtonState(quickViewModal, swat, showNotification);
                                deferred.resolve(lists);
                            };
                            const onError = error => {
                                console.error("Error fetching wishlists:", error);
                                deferred.reject(error);
                            };
                            swat.fetchLists({
                                callbackFn: onSuccess,
                                errorFn: onError
                            });
                        })).promise();
                    }
                    function updateButtonState(quickViewModal, swat, showNotification) {
                        quickViewModal.find(".swym-add-to-wishlist").each((function() {
                            const $button = $(this);
                            const productId = $button.data("product-id");
                            const variantId = $button.data("variant-id");
                            const isInWishlist = window.swymWishLists?.some((list => list.listcontents.some((item => item.epi === parseInt(variantId, 10) || item.empi === parseInt(productId, 10)))));
                            if (isInWishlist) {
                                $button.addClass("swym-added");
                            } else {
                                $button.removeClass("swym-added");
                            }
                            if (showNotification) {
                                let successMessage = isInWishlist ? "Successfully added to wishlist." : "Product removed from wishlist.";
                                swat.ui.showSuccessNotification({
                                    message: successMessage
                                });
                            }
                        }));
                    }
                    function bindAddToWishlist() {
                        if (typeof window._swat === "undefined" && typeof window.SwymCallbacks === "undefined") {
                            console.log("Swym is not available, skipping wishlist functionality.");
                            return;
                        }
                        if (!window.SwymCallbacks) {
                            window.SwymCallbacks = [];
                        }
                        const quickViewModal = $("#QuickView-Modal");
                        if (quickViewModal.length === 0) {
                            console.log("No QuickView-Modal found, skipping bindAddToWishlist.");
                            return;
                        }
                        window.SwymCallbacks.push((() => {
                            const swat = window._swat;
                            quickViewModal.find(".swym-add-to-wishlist").each((function() {
                                const $button = $(this);
                                if ($button.data("initialized")) return;
                                $button.data("initialized", true);
                                $button.on("click", (function() {
                                    const productId = $button.data("product-id");
                                    const variantId = $button.data("variant-id");
                                    const productUrl = $button.data("product-url");
                                    const lid = window.swymSelectedListId;
                                    const product = {
                                        epi: parseInt(variantId, 10),
                                        empi: parseInt(productId, 10),
                                        du: productUrl
                                    };
                                    const onSuccess = () => {
                                        console.log("Operation successful");
                                        fetchList(swat, quickViewModal, true);
                                    };
                                    const onError = error => {
                                        console.error("Error during wishlist operation:", error);
                                        alert("Something went wrong. Please try again later.");
                                    };
                                    if ($button.hasClass("swym-added")) {
                                        swat.deleteFromList(lid, product, onSuccess, onError);
                                    } else {
                                        swat.addToList(lid, product, onSuccess, onError);
                                    }
                                }));
                            }));
                            fetchList(swat, quickViewModal, false).catch((error => {
                                console.error("Error initializing wishlist:", error);
                            }));
                        }));
                    }
                    window.bindAddToCartEvents = bindAddToCartEvents;
                    window.bindAddToWishlist = bindAddToWishlist;
                }
            }));
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();